<template>
    <div>
        <div class="landing-form-title learnworlds-heading3-normal mb-30">
            {{ i18n.get('common.password_reset') }}
        </div>

        <div>
            <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                {{ i18n.get('common.sign_up_what_email') }}
            </div>
            
            <input v-model="email" 
                   v-validate="'required|email'"
                   name="email" 
                   type="email" 
                   :placeholder="i18n.get('common.sign_up_email')"
                   class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal 
                   learnworlds-element"/>
            
            <span>
                {{ errors.first('email') }}
            </span>
        </div>

        <div class="-form-buttons flex a-i-c">
            <div class="landing-form-small-button reset-pass-btn js-enterFocus learnworlds-button-small 
                        learnworlds-button learnworlds-button-solid-accent1">
                <span class="btn-lbl" @click.prevent="submit">
                    {{ i18n.get('common.ok') }}
                </span>
            </div>
            <div class="landing-form-small-button js-animated-close learnworlds-button-small learnworlds-button learnworlds-button-solid-brand">
                <span class="btn-lbl" @click.prevent="showLoginForm">
                    {{ i18n.get('common.cancel') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "../../commonjs/axios";
    import AuthenticationMixin from "./AuthenticationMixin";

    export default {
        name: "ForgotPasswordComponent",
        
        data() {
            return {
                email: ''
            }    
        },
        
        methods: {
            submit() {
                return new Promise((resolve, reject) => {
                    axios.post(`${this.clientURL}/api/password-reset-init`, {
                        'email': this.email
                    }).then(response => {
                        if (response.data.success) {
                            // this.successCallback(this.generateRedirectUrl(response));
                            this.successCallback(response)
                            resolve();
                        } else {
                            reject();
                            console.log(response);
                        }
                    }).catch(error => {
                        reject();
                        console.log(error);
                    })
                });
            },
        },
        
        mixins: [
            AuthenticationMixin
        ]
    }
</script>
